
import { defineComponent, PropType } from 'vue'
import { NumberFormatter } from '@/lib/number-formatter'
import { CreditCard } from '@/types'
import { Payment } from '@/types/order'

import FormattableField from './FormattableField.vue'

export default defineComponent({
  components: {
    FormattableField
  },
  props: {
    payment: {
      type: Object as PropType<Payment>,
      required: true
    },
    isRegistered: {
      type: Boolean,
      required: true
    },
    registeredCreditCard: {
      type: Object as PropType<CreditCard>,
      required: false
    },
    isSample: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      showRegisteredCard: this.isRegistered
    }
  },
  computed: {
    isCreditCardSelected (): boolean {
      return this.payment.method === 'creditCard'
    },
    isDeferredSelected (): boolean {
      return this.payment.method === 'deferred'
    },
    isSampleSelected (): boolean {
      return this.payment.method === 'sampleOrder'
    }
  },
  emits: ['input', 'edit-registered-card'],
  methods: {
    emitInput (value: unknown, key: string) {
      this.$emit('input', { ...this.payment, [key]: value })
    },
    emitCheckboxInput ({ target }: { target: HTMLInputElement }, key: string) {
      this.$emit('input', { ...this.payment, [key]: target.checked })
    },
    validateCardNumber (value: string) {
      if (!this.isCreditCardSelected) return true
      if (!value.trim().length) return false
      return /^\d{4}-\d{4}-\d{4}-\d{3,4}$/.test(value)
    },
    formatCardNumber (value: string) {
      return NumberFormatter.creditCardNumber(value)
    },
    validateCardExpiration (value: string) {
      if (!this.isCreditCardSelected) return true
      if (!value.trim().length) return false
      if (!/^\d{2}\/\d{2}$/.test(value)) return false
      return value.length <= 7
    },
    formatCardExpiration (value: string) {
      return NumberFormatter.creditCardExpiration(value)
    },
    validateCardSecurityCode (value: string) {
      if (!this.isCreditCardSelected) return true
      if (!value.trim().length) return false
      if (!/^[0-9]{3,4}$/.test(value)) return false
      return value.length <= 4
    },
    formatCardSecurityCode (value: string) {
      return NumberFormatter.creditCardSecurityCode(value)
    },
    handleEditRegisteredCard () {
      this.showRegisteredCard = false
      this.$emit('edit-registered-card')
    }
  }
})
